import Component from '../Component';

class Cookies extends Component {
  attachEventListeners() {
    const cookieSettings = document.querySelectorAll('.cookie_settings');

    cookieSettings.forEach((button) => button.addEventListener('click', (e) => {
      e.preventDefault();
      this.root.classList.remove('has_responded');
    }));
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default Cookies;
